// extracted by mini-css-extract-plugin
export default {"wrapper":"vp","form":"wp","required":"xp","label":"yp","noMargin":"zp","success":"Ap","circle":"Bp","successText":"Cp","smallprint":"Dp"};